function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m19 5v-2.25c0-1.517-1.233-2.75-2.75-2.75h-8.5c-1.517 0-2.75 1.233-2.75 2.75v2.25z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m21.25 6h-18.5c-1.517 0-2.75 1.233-2.75 2.75v6.5c0 1.517 1.233 2.75 2.75 2.75h1.25v-4.25c0-.965.785-1.75 1.75-1.75h12.5c.965 0 1.75.785 1.75 1.75v4.25h1.25c1.517 0 2.75-1.233 2.75-2.75v-6.5c0-1.517-1.233-2.75-2.75-2.75z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m18.25 13h-12.5c-.414 0-.75.336-.75.75v7.5c0 1.517 1.233 2.75 2.75 2.75h8.5c1.517 0 2.75-1.233 2.75-2.75v-7.5c0-.414-.336-.75-.75-.75zm-9.5 3.5h1.5c.414 0 .75.336.75.75s-.336.75-.75.75h-1.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75zm5.5 4.5h-5.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h5.5c.414 0 .75.336.75.75s-.336.75-.75.75z"
});

var SvgPrint = function SvgPrint(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    id: "bold",
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrint, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/print.957a8f90.svg";
export { ForwardRef as ReactComponent };